import { render, staticRenderFns } from "./distribution-multidiagram.vue?vue&type=template&id=989ccfa2&"
import script from "./distribution-multidiagram.vue?vue&type=script&lang=js&"
export * from "./distribution-multidiagram.vue?vue&type=script&lang=js&"
import style0 from "./distribution-multidiagram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports